import _asyncToGenerator from "/Users/liuli/Documents/hu/riscern-pc-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withKeys as _withKeys, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/search/icon_clean.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-51fd7a1e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "search-page",
  id: "searchBar",
  hidefocus: "true"
};
var _hoisted_2 = {
  class: "search"
};
var _hoisted_3 = ["src"];

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});

var _hoisted_5 = {
  class: "search-right"
};

var _hoisted_6 = /*#__PURE__*/_createTextVNode("search");

var _hoisted_7 = {
  class: "content"
};
var _hoisted_8 = {
  key: 0,
  class: "history"
};
var _hoisted_9 = {
  class: "list"
};
var _hoisted_10 = ["onClick"];

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "clear-btn"
  }, "Clean history", -1);
});

var _hoisted_13 = [_hoisted_11, _hoisted_12];
var _hoisted_14 = {
  class: "country"
};
var _hoisted_15 = ["onClick"];

var _hoisted_16 = /*#__PURE__*/_createTextVNode(" Latest ");

var _hoisted_17 = {
  class: "high-text"
};
var _hoisted_18 = {
  class: "country-company"
};
var _hoisted_19 = ["onClick"];
var _hoisted_20 = {
  class: "country-tip"
};

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode("'Latest company' means the company was established in the "), /*#__PURE__*/_createElementVNode("span", {
    class: "high-text"
  }, "last month.")], -1);
});

var _hoisted_22 = {
  class: "jurisdiction"
};
var _hoisted_23 = {
  class: "jurisdiction-list"
};
var _hoisted_24 = ["onClick"];
var _hoisted_25 = ["src"];
var _hoisted_26 = {
  key: 0
};
import { onMounted, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Search } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import { apiLatestCompany } from '../../api/home';
import { utilLocalStorage } from '../../utils/local-stroage';
import { jurisdictionList } from '../../utils/constData';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var jurisdictionShow = ref(false);
    var router = useRouter();
    /** *******************************国家/公司选择*****************************************************/
    // 国家/公司显示

    var countryList = reactive({
      'Chinese Company': 'cnList',
      'Japanese Company': 'jpList',
      'Taiwanese Company': 'twList'
    }); // 公司数据

    var companyMapData = ref({}); // 国家/公司显示

    var companyShow = ref(false); // 公司选择

    var companySelect = ref(''); // 获取公司数据

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return apiLatestCompany();

            case 2:
              data = _context.sent;
              companyMapData.value = data.data;
              companySelect.value = 'cnList';
              handleSearchKeyTime(data.data); // searchBar点击后可以消失

              handleSearchBarBlur();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))); // 选择公司内的国家

    function onCountrySelect(value) {
      companySelect.value = value;
    } // 选择公司


    function onFocusCompanyInput() {
      jurisdictionShow.value = false;
      setTimeout(function () {
        companyShow.value = true;
      }, 100);
    }
    /** *******************************历史记录 **********************************************/

    /** 历史记录列表 */


    var historyList = ref(utilLocalStorage.getLocalStorageCompany());
    var fullscreenLoading = ref(false); // 跳转CompanyInfo

    function onHrefCompanyInfo(data) {
      fullscreenLoading.value = true;
      router.push({
        name: 'CompanyInfo',
        query: {
          key: data.keyNo
        }
      });
    }

    function onHrefSearch(query) {
      // 查询数据记录，并跳转至查询列表页面
      var list = utilLocalStorage.setLocalStorageCompany(query);
      router.push({
        name: 'Search',
        query: {
          key: query.entityName,
          code: query.countryCode
        }
      });
    } // 清空历史记录


    function onClearHistory() {
      historyList.value = [];
      utilLocalStorage.removeLocalStorageCompany();
    }
    /** **********选择区域***************/


    var jurisdictionCode = ref({}); // 点击选择国家

    function onClickJurisdiction() {
      if (companyShow.value) {
        companyShow.value = false; // 延迟点，好看

        setTimeout(function () {
          jurisdictionShow.value = true;
        }, 300);
      } else {
        setTimeout(function () {
          jurisdictionShow.value = true;
        }, 100);
      }
    } // 点击选择区域


    function onSelectHurisdiction(item) {
      // 根据选择的区域切换 国家默认选择
      var convertMap = {
        86: 'Chinese Company',
        81: 'Japanese Company',
        886: 'Taiwanese Company'
      };
      var country = convertMap[item.code];
      companySelect.value = countryList[country];
      jurisdictionCode.value = item;
      jurisdictionShow.value = false;
    }
    /** ************************ search输入框 ***************************/
    // 输入框placeholder


    var searchKey = ref(''); // 输入框真实值

    var searchKeyText = ref('');

    function handleSearchKeyTime(list) {
      var arr = [];
      Object.keys(list).forEach(function (item) {
        arr = arr.concat(list[item]);
      });
      var count = 0;
      searchKey.value = arr[0].entityName; // 5秒换一次

      setInterval(function () {
        if (count === arr.length - 1) {
          count = 0;
        } else {
          count++;
        }

        searchKey.value = arr[count].entityName;
      }, 5000);
    } // 提交，保存localStroage && 跳转搜索页


    function handleSubmitForm() {
      var _jurisdictionCode$val;

      if (!jurisdictionCode.value.code) return ElMessage.error('please select jurisdiction');
      if (!searchKeyText.value) return ElMessage.error('please input company name');
      var query = {
        countryCode: (_jurisdictionCode$val = jurisdictionCode.value) === null || _jurisdictionCode$val === void 0 ? void 0 : _jurisdictionCode$val.code,
        entityName: searchKeyText.value
      };
      onHrefSearch(query);
    } // 处理点击空白处关闭


    function handleSearchBarBlur() {
      document.addEventListener('click', function (e) {
        var typePanel = document.getElementById('searchBar');

        if (typePanel) {
          if (!typePanel.contains(e.target)) {
            companyShow.value = false;
            jurisdictionShow.value = false;
          }
        }
      });
    }

    return function (_ctx, _cache) {
      var _component_ArrowDownBold = _resolveComponent("ArrowDownBold");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_button = _resolveComponent("el-button");

      var _component_WarningFilled = _resolveComponent("WarningFilled");

      var _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        modelValue: searchKeyText.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return searchKeyText.value = $event;
        }),
        placeholder: searchKey.value,
        onFocus: onFocusCompanyInput,
        onKeypress: _withKeys(handleSubmitForm, ["enter"])
      }, {
        prepend: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "country-select",
            onClick: onClickJurisdiction
          }, [jurisdictionCode.value.src ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: jurisdictionCode.value.src
          }, null, 8, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(jurisdictionCode.value.name || 'Jurisdiction'), 1), _createVNode(_component_el_icon, {
            class: _normalizeClass(jurisdictionShow.value ? 'arrow-icon-show' : 'arrow-icon')
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_ArrowDownBold)];
            }),
            _: 1
          }, 8, ["class"]), _hoisted_4])];
        }),
        _: 1
      }, 8, ["modelValue", "placeholder", "onKeypress"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
        class: "btn",
        color: "#FE8550",
        icon: _unref(Search),
        onClick: handleSubmitForm
      }, {
        default: _withCtx(function () {
          return [_hoisted_6];
        }),
        _: 1
      }, 8, ["icon"])])]), _createVNode(_Transition, {
        name: "el-zoom-in-top"
      }, {
        default: _withCtx(function () {
          return [_withDirectives(_createElementVNode("div", _hoisted_7, [historyList.value && historyList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyList.value, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              class: "item",
              key: index,
              onClick: function onClick($event) {
                return onHrefSearch(item);
              }
            }, _toDisplayString(item.entityName), 9, _hoisted_10);
          }), 128))]), _createElementVNode("div", {
            class: "clear",
            onClick: onClearHistory
          }, _hoisted_13)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(countryList)), function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['country-item', companySelect.value === _unref(countryList)[item] ? 'country-item-active' : '']),
              key: item,
              onClick: function onClick($event) {
                return onCountrySelect(_unref(countryList)[item]);
              }
            }, [_hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString(item), 1)], 10, _hoisted_15);
          }), 128))]), _createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyMapData.value[companySelect.value], function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "country-company-item",
              key: item.keyNo,
              onClick: function onClick($event) {
                return onHrefCompanyInfo(item);
              }
            }, _toDisplayString(item.entityName), 9, _hoisted_19);
          }), 128))]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_icon, {
            color: "#FE8550"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_WarningFilled)];
            }),
            _: 1
          }), _hoisted_21])], 512), [[_vShow, companyShow.value]])];
        }),
        _: 1
      }), _createVNode(_Transition, {
        name: "el-zoom-in-top"
      }, {
        default: _withCtx(function () {
          return [_withDirectives(_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(jurisdictionList), function (item, index) {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: item.code
            }, [_createElementVNode("div", {
              class: _normalizeClass(['jurisdiction-item', jurisdictionCode.value.code === item.code ? 'item-active' : '']),
              onClick: function onClick($event) {
                return onSelectHurisdiction(item);
              }
            }, [_createElementVNode("img", {
              src: item.src
            }, null, 8, _hoisted_25), _createElementVNode("span", null, _toDisplayString(item.name), 1)], 10, _hoisted_24), index === 2 ? (_openBlock(), _createElementBlock("br", _hoisted_26)) : _createCommentVNode("", true)], 64);
          }), 128))])], 512), [[_vShow, jurisdictionShow.value]])];
        }),
        _: 1
      })])), [[_directive_loading, fullscreenLoading.value, void 0, {
        fullscreen: true,
        lock: true
      }]]);
    };
  }
});